import { render, staticRenderFns } from "./03_rollscreen.vue?vue&type=template&id=45d40e81&scoped=true&"
import script from "./03_rollscreen.vue?vue&type=script&lang=js&"
export * from "./03_rollscreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d40e81",
  null
  
)

export default component.exports